/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * HyusnSu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Wed May 03 2023
 **/

import { Button, Column, Typography, useModal } from "@/frameworks/designStuff/components";
import { _T, _P } from "@rfice/language";
import { EventHandler } from "@rfice/eventhandler";

import * as S from "./emotion";
import { subTypoCss } from "./emotion";
import { EventID, SidebarID } from "@/frameworks/core/commons";
import { ModalID } from "@/frameworks/core/commons";
import { useSidebarActions } from "@/frameworks/core/hooks";

export default function GroupAloneManager({ name, groupID }: { name: string; groupID: string }) {
	const modal = useModal();
	const sidebarActions = useSidebarActions();

	const handleDelete = () => {
		sidebarActions.show(SidebarID.GroupSetting);
		EventHandler.emit(EventID.OPEN_GROUP_SETTING, { groupID });

		modal.hide(ModalID.GROUP_ALONE_MANAGER);
	};

	const handleCancel = () => {
		modal.hide(ModalID.GROUP_ALONE_MANAGER);
	};

	const message = _T("#{{spaceName}}#의 유일한 관리자입니다.", {
		spaceName: name
	}).split("#");
	return (
		<S.Wrapper gap={10} horizonAlign="center">
			<S.Body horizonAlign="center">
				<Typography.p typoSize="Title1_B">{message[0]}</Typography.p>
				<Typography.p typoSize="Body2">{message[1]}</Typography.p>
				<Column css={subTypoCss} horizonAlign="center">
					{_P(
						"<p id='subTypoFirst'>관리자를 이관하고 탈퇴해주세요.</p> <p id='subTypoLast'> (운영중인 스페이스가 있을 경우, 스페이스 관리자도 이관해야 합니다.)<p>"
					)}
				</Column>
			</S.Body>
			<S.Footer horizonAlign="center" verticalAlign="center">
				<Button.Group>
					<Button filled="secondary" onClick={handleCancel}>
						{_T("취소")}
					</Button>
					<Button onClick={handleDelete}>{_T("확인")}</Button>
				</Button.Group>
			</S.Footer>
		</S.Wrapper>
	);
}
